import { useFeatureFlags } from "@packsize/feature-flags";
import { type MachineType } from "@packsize/schemas/machines";

export const useIsMachineTypeEnabled = () => {
	const { isFeatureFlagEnabled } = useFeatureFlags();
	const isCvpRangeEnabled = isFeatureFlagEnabled("cvp-range-allow-machine");
	const isSealProXEnabled = isFeatureFlagEnabled("seal-pro-x-allow-machine");

	return (machineType: MachineType): boolean => {
		if (machineType === "CVPRange") {
			return isCvpRangeEnabled === true;
		}

		if (machineType === "SealProX") {
			return isSealProXEnabled === true;
		}

		return true;
	};
};
